/** Aide et assistance MyEquip, pour tous les rôles internes (§26.10). */
import { lazy } from 'react';
import type { AppRoute } from '../../app/route-types.js';

const HelpPage = lazy(() => import('./HelpPages.js').then((m) => ({ default: m.HelpPage })));
const HelpTopicPage = lazy(() => import('./HelpPages.js').then((m) => ({ default: m.HelpTopicPage })));
const SupportRequestNewPage = lazy(() => import('./HelpPages.js').then((m) => ({ default: m.SupportRequestNewPage })));
const SupportRequestPage = lazy(() => import('./HelpPages.js').then((m) => ({ default: m.SupportRequestPage })));

export const helpRoutes: AppRoute[] = [
  { path: '/aide', element: <HelpPage /> },
  { path: '/aide/sujets/:manual/:slug', element: <HelpTopicPage /> },
  { path: '/aide/nouvelle-demande', element: <SupportRequestNewPage /> },
  { path: '/aide/demandes/:id', element: <SupportRequestPage /> },
];
